namespace appn.infer {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    let recognition: SpeechRecognition;
    let currentBtn: JQuery<HTMLElement>;
    let currentBox: JQuery<HTMLElement>;
    let currentSTTTranscript: string;
    
    export function hookPromptDialog(inferUrl: string, successFn: Function) {
        const $promptText = $('#promptDialog .prompt-text') as JQuery<HTMLTextAreaElement>;
        hookSpeechToText($('#promptDialog .prompt-speech'), $promptText);
        hookInfer($('#promptDialog #promptDialog-go'), $promptText, inferUrl, successFn);

        $('#promptDialog').on('hide.bs.modal', function() {
            togglePrompt(false);
        });
    }
    
    export function hookSpeechToText(launchBtn: JQuery<HTMLElement>, toTextArea: JQuery<HTMLElement>) {
        launchBtn.on('click', function(event: Event) {
            event.preventDefault();
            speechToText(launchBtn, toTextArea);
        });
    }
    
    export function setupAutoInputGrow(textArea: JQuery<HTMLElement>) { 
        if (!textArea || !textArea.length) return;
        const resize = () => setupAutoInputResize(textArea);
        textArea.on('input', resize);
    }
    
    function setupAutoInputResize(textArea: JQuery<HTMLElement>) {
        if (textArea.attr("data-input-grow")) {
            textArea.css('height', 'auto');
            textArea.css('height', `${textArea[0].scrollHeight + 2}px`);
        }
    }

    function speechToText(launchBtn: JQuery<HTMLElement>, toTextArea: JQuery<HTMLElement>) {

        if (typeof SpeechRecognition === "undefined") {
            appn.toast.notify(appn.toast.Type.error, T('Speech recognition is not available in your browser version'));
            return;
        }
        
        if (currentBtn === undefined || currentBtn !== launchBtn) {
            togglePrompt(false);

            recognition = new SpeechRecognition();
            recognition.continuous = true;
            recognition.interimResults = true;
            
            currentBtn = launchBtn;
            currentBox = toTextArea;
            currentSTTTranscript = toTextArea.val() ? toTextArea.val() + ' ' : '';
            
            hookSTTHandlers();
        }
        
        togglePrompt(true);
    }
    
    function hookSTTHandlers()
    {
        const onResult = (event) => {
            let interimTranscript = '';
            
            for (let i = event.resultIndex; i < event.results.length; ++i) {
                const transcript = event.results[i][0].transcript;
                if (event.results[i].isFinal)
                    currentSTTTranscript += transcript + ' ';
                else
                    interimTranscript += transcript;
            }

            // Combined final and interim results gives progressive, "live" typing effect.
            currentBox.val(currentSTTTranscript + interimTranscript);

            setupAutoInputResize(currentBox);
        };
        recognition.removeEventListener("result", onResult);
        recognition.addEventListener("result", onResult);

        const onError = (event) => {
            console.error('Speech Recognition Error: ', event.error);

            togglePrompt(false);

            let title = T('Unknown Error');
            let msg = T('Speech recognition failed with error: {0}', event.error);
            if (event.error === 'permission-denied' || event.error === 'not-allowed') {
                title = T('Permission Denied');
                msg = T('Microphone permission was denied or a system-level block exists. Please update your browser settings.');
            } else if (event.error === 'no-speech') {
                title = T('No Speech Detected');
                msg = T('Please check your microphone and try again.');
            } else if (event.error === 'network') {
                title = T('Network Error');
                msg = T('Speech recognition failed due to a network error. This can happen with an unstable internet connection or an unsupported browser. For best results, please use a recent version of Chrome, Edge, or Safari.');
            }
            appn.toast.notify(appn.toast.Type.error, msg, title);
        };
        recognition.removeEventListener("error", onError);
        recognition.addEventListener("error", onError);
    }
    
    export function togglePrompt(activate?: boolean)
    {
        if (currentBtn === undefined)
            return;
        
        if (activate === false || currentBtn.hasClass('prompt-in-progress')) {
            currentBtn.removeClass('prompt-in-progress');
            currentBox.removeClass('prompt-in-progress');
            recognition.stop();
        }
        else {
            const currentVal = currentBox.val() as string;
            currentSTTTranscript = currentVal ? currentVal.trimEnd() + ' ' : '';
            
            currentBtn.addClass('prompt-in-progress');
            currentBox.addClass('prompt-in-progress');
            recognition.start();
        }
    }

    export function hookInfer(launchBtn: JQuery<HTMLElement>, fromTextArea: JQuery<HTMLTextAreaElement>, inferUrl: string, successFn: Function) {
        launchBtn.on('click', function(event: Event) {
            event.preventDefault();

            const $modal = launchBtn.closest('.modal');
            const $fileInput = $modal.find('.prompt-file-input') as JQuery<HTMLInputElement>;
            const file = $fileInput.length > 0 && $fileInput[0].files ? $fileInput[0].files[0] : null;

            if (fromTextArea[0].value.length < 10 && !file) {
                appn.toast.notify(toast.Type.error, T('A minimum of 10 characters or a document attachment is required to proceed.'), T('Insufficient Prompt'));
                return;
            }
            
            appn.dialog.showLoading(T('Magic in progress...please wait'));

            const formData = new FormData();
            formData.append('userPrompt', fromTextArea[0].value);
            if (file) {
                formData.append('attachment', file);
            }

            appn.ajax.post({
                url: inferUrl,
                dataType: 'json',
                data: formData,
                processData: false,
                contentType: false,
                done: function(data) {
                    if (data === undefined || !data) {
                        appn.toast.notify(toast.Type.error, T('Failed to run the necessary AI inference. Please try again.'), T('Inference Failed'));
                        return;
                    }
                    if (data.Error) {
                        appn.toast.notify(toast.Type.error, data.Error.message, data.Error.title);
                        return;
                    }
                    if (data.RedirectTo) {
                        appn.location.navTo(data.RedirectTo);
                        return;
                    }
                    
                    successFn(data);
                },
                fail: function() {
                    appn.toast.notify(toast.Type.error, T('Failed to run the necessary AI inference. Please try again.'), T('Inference Failed'));
                },
                always: function() {
                    appn.dialog.hideLoading();
                }
            });
        });
    }
}
